import fetch from '@/utils/fetch'
// api
export function getProblemList (problemMain, problemGuid, keywords, title, qt, pageIndex, rows) {
  console.log('getProblemList----problemMain==' + problemMain)
  return fetch({
    url: '/getProblemList',
    params: {
      problemMain,
      problemGuid,
      keywords,
      title,
      qt,
      pageIndex,
      rows
    },
    method: 'get'
  })
}

export function getProblemTotal (problemMain, problemGuid, keywords, title, qt) {
  return fetch({
    url: '/getProblemTotal',
    params: {
      problemMain,
      problemGuid,
      keywords,
      title,
      qt
    },
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api_problemList.js